import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/stores/store';

export const selectCameraFeature = (s: RootState) => s.editor.camera;

export const selectCameraPosition = createSelector(
  [selectCameraFeature],
  (s) => s.position,
);

export const selectCameraViewport = createSelector(
  [selectCameraFeature],
  (s) => s.viewport,
);

export const selectCameraZoom = createSelector(
  [selectCameraFeature],
  (s) => s.zoom,
);

export const selectCameraRotation = createSelector(
  [selectCameraFeature],
  (s) => s.rotation,
);

export const selectCameraTarget = createSelector(
  [selectCameraFeature],
  (s) => s.target,
);
